<div class="m-tooltip" [style.left.px]="position.x" [style.top.px]="position.y">
  <div class="m-tooltip-text">{{ content }}</div>
  @if (imageUrl) {
    <img [src]="imageUrl" class="m-tooltip-image">
  }
  <div class="m-tooltip-arrow"></div>
</div>
